import ObjectCopyService from "external-services/object-copy-service/index";
import TrackingService from 'app/services/tracking/tracking.service';
import SectionLookupService from "external-services/section-lookup-service/sectionLookup.service";
import TablesLookupService from 'external-services/tables-lookup-service/tablesLookup.service';
import LayoutsService from 'external-services/layouts-service/layouts.service';
import GridSyncService from 'app/services/gridSync/gridSync.service';
import DateUtilsService from "external-services/date-utils-service";
import PouchLoadService from "external-services/pouch-load-service/index";

const NS = 'NewLayoutCtrl'; // jshint ignore:line

export default function NewLayoutCtrl(
  $log, $state, $stateParams, $filter, $mdToast, $mdDialog,
  tablesService
) {
  "ngInject";

  const vm = this;

  var validFromDate = DateUtilsService.dateToIdStr(new Date(2000, 0, 1));
  var layoutToDuplicate;
  var tablesToDuplicate;
  //-- define public properties
  vm.layout = {
    _id: PouchLoadService.getNewId(['layout'], true, [validFromDate]),
    tables: [],
    type: 'layout',
    name: '',
    sectionId: null
  };
  vm.tables = [];
  vm.shapes = tablesService.shapes;
  vm.availableOptions = tablesService.availableOptions;
  // states
  vm.LOADING = 1;
  vm.ENTER = 0;
  vm.SAVED = 2;
  vm.ERROR = 3;
  vm.state = vm.ENTER;
  //-- define public methods
  vm.cancel = cancel;
  vm.save = save;
  vm.tryAgain = tryAgain;
  vm.addTable = addTable;
  vm.deleteTable = deleteTable;

  getSections();

  if ($stateParams.id) {
    vm.duplicate = true;
    vm.state = vm.LOADING;
    getLayout();
  }

  function getSections() {
    SectionLookupService.getSections().then(function (sections) {
      vm.sections = sections;
      if (!vm.tables.length && !$stateParams.id) {
        addTable();
      }
    }).catch(function () {
      $log.error('Failed to get all sections');
    });
  }

  function getLayout() {
    var id = decodeURIComponent($stateParams.id);
    LayoutsService.getLayoutById(id).then(function (layout) {

      layoutToDuplicate = layout;
      vm.duplicateName = layoutToDuplicate.name;
      getTables();
    }).catch(function (err) {
      $log.error('Failed to load layout', err);
    });
  }

  function getTables() {
    TablesLookupService.getAllTablesByIds(layoutToDuplicate.tables).then(function (tables) {
      tablesToDuplicate = $filter('alphaSortFilter')(tables, 'name');
      duplcateLayout();
    }).catch(function (err) {
      $log.error('Failed to load tables', err);
    });
  }

  function duplcateLayout() {
    // assign the same section
    vm.layout.sectionId = layoutToDuplicate.sectionId;
    // create the list of tables from the saved ones
    var newIdLookUp = {};
    for (var i = 0; i < tablesToDuplicate.length; i++) {
      var tableToCopy = tablesToDuplicate[i];
      var table = ObjectCopyService.angularSafeCopy(tableToCopy);
      delete table._rev;
      delete table._id;
      table._id = PouchLoadService.getNewId(['table']);
      newIdLookUp[tableToCopy._id] = table._id;
      vm.tables.push(table);
    }
    /**
     if (layoutToDuplicate.tablesJoins && layoutToDuplicate.tablesJoins.length) {
            // the layout has table joins
            vm.layout.tablesJoins = [];
            for (var j = 0; j < layoutToDuplicate.tablesJoins.length; j++) {
                var joinToCopy = layoutToDuplicate.tablesJoins[j];
                var tableJoin = angular.copy(joinToCopy);
                tableJoin.tables = [];
                for (var t = 0; t < joinToCopy.tables.length; t++) {
                    // look up the new table joins and add them to the new layout
                    tableJoin.tables.push(newIdLookUp[joinToCopy.tables[t]]);
                };
                vm.layout.tablesJoins.push(tableJoin);
            }
        }
     **/

    vm.state = vm.ENTER;
  }

  function tryAgain() {
    vm.state = vm.ENTER;
  }

  function addTable() {
    var lastTable = vm.tables[vm.tables.length - 1];
    vm.tables.push({
      name: '',
      order: (lastTable) ? lastTable.order + 1 : 1,
      shared: false,
      capacity: 2,
      minCapacity: 1,
      online: true,
      walkinOnly: false,
      availableOption: 'all',
      type: 'table',
      _id: PouchLoadService.getNewId(['table'])
    });
  }

  function deleteTable(evt, table, index) {
    var confirm = $mdDialog.confirm()
      .parent(angular.element(document.body))
      .title('Remove table?')
      .content('Are you sure you would like to remove this table ' + table.name + '')
      .ariaLabel('Remove table')
      .ok('Yes')
      .cancel('No')
      .targetEvent(evt);
    $mdDialog.show(confirm).then(function () {
      vm.tables.splice(index, 1);
    });
  }

  function cancel() {
    $state.go('settings.layouts');
  }

  function save(isValid) {
    if (isValid) {
      var layout = ObjectCopyService.angularSafeCopy(vm.layout);
      // add the tables to the layout,
      var layoutTableIds = [];
      for (var i = vm.tables.length - 1; i >= 0; i--) {
        var table = vm.tables[i];
        if (!table.shape) {
          if (table.capacity <= 4) {
            table.shape = 'square';
          } else {
            table.shape = 'rect';
          }
        }
        layoutTableIds.push(table._id);
        table.sectionId = vm.layout.sectionId;
      }
      layout.tables = layoutTableIds;
      tablesService.updateLayout(new Date(), layout, vm.tables).then(function (result) {
        // CLI-165: notify the Grid Sync API of the new layout
        GridSyncService.layoutCreated(result && result.savedLayout ? result.savedLayout._id : layout._id);

        $mdToast.show(
          $mdToast.simple()
            .content('Layout Created')
            .position('bottom right')
            .theme('saved')
            .hideDelay(3000)
        );

        TrackingService.trackEvent('New Layout', {
          id: layout._id
        });
        $state.go('settings.layouts');
      }).catch(function (err) {
        $log.error(err);
        vm.state = vm.ERROR;
      });

    } else {
      vm.displayErrors = true;
    }
  }
}
